exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-057c1de9]{position:fixed;z-index:102}.faces[data-v-057c1de9]{flex-flow:column nowrap!important}.tab-content-inner[data-v-057c1de9]{width:100%;height:100%}.content-wrapper[data-v-057c1de9]{position:relative;padding-top:10px}.details[data-v-057c1de9]{text-decoration:none}", ""]);

// exports
